import React from 'react';
import PropTypes from 'prop-types';

import {
  UamMessagePanelContainer,
  UamMessagePanelMessage,
  UamMessagePanelTitle,
} from './UamMessagePanelStyles';

const UamMessagePanel = ({ header, children }) => (
  <UamMessagePanelContainer>
    <UamMessagePanelTitle>{header}</UamMessagePanelTitle>

    <UamMessagePanelMessage>
      {children}
    </UamMessagePanelMessage>
  </UamMessagePanelContainer>
);

UamMessagePanel.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default UamMessagePanel;
